// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout5_wrapper__1X5gV","user":"Layout5_user__2-GMe","mainUser":"Layout5_mainUser__2y0Qq","topRow":"Layout5_topRow__IlvhH","bottomRow":"Layout5_bottomRow__3moQy"};